import type { InjectionKey, Ref } from 'vue'

export const FORM_ITEM_INJECTION_KEY
  = Symbol('formItem') as InjectionKey<string>

export const FORM_PROCESSING_INJECTION_KEY
  = Symbol('formProcessing') as InjectionKey<Ref<boolean>>
